/**
 * Pencereyi basliktan tasima. Baslik iframe'in icinde oldugu icin yukleyici (static/scripts.js) onun
 * fare olaylarini goremez; burada yakalanan hareket "header-drag" komutuyla ust pencereye iletilir,
 * yukleyici de "Tasi" tutamaciyla ayni tasima kodunu calistirir. Ekran koordinati gonderilir:
 * iframe tasindikca ic koordinatlar kayar, ekran koordinati kaymaz.
 */
const HEADER_SELECTOR = "#chatHeader, .sps-shell-header, .sps-help__header, [data-drag-header]";
// baslik icindeki dugme ve alanlar tiklanabilir kalsin
const INTERACTIVE_SELECTOR = "button, a, input, textarea, select, label, [role='button'], [role='menuitem'], .ant-dropdown-trigger, .ant-select";
// tiklama ile surukleme ayrilsin; tik ile konum kaydedilmesin
const DRAG_THRESHOLD = 4;

const isPanelPreview = () => window.self !== window.top && window.location.search.indexOf("preview") !== -1;

const post = (phase, e) => {
    window.parent.postMessage({ command: "header-drag", payload: { phase, x: e.screenX, y: e.screenY } }, "*");
};

export const installHeaderDrag = () => {
    if (window.self === window.parent || isPanelPreview()) return;
    document.addEventListener(
        "pointerdown",
        (down) => {
            if (down.button !== 0 || down.pointerType === "touch") return;
            const target = down.target;
            if (!target || !target.closest || !target.closest(HEADER_SELECTOR) || target.closest(INTERACTIVE_SELECTOR)) return;
            let started = false;
            const onMove = (e) => {
                if (!started) {
                    if (Math.abs(e.screenX - down.screenX) < DRAG_THRESHOLD && Math.abs(e.screenY - down.screenY) < DRAG_THRESHOLD) return;
                    started = true;
                    post("start", down);
                }
                post("move", e);
            };
            const onUp = (e) => {
                window.removeEventListener("pointermove", onMove, true);
                window.removeEventListener("pointerup", onUp, true);
                window.removeEventListener("pointercancel", onUp, true);
                if (started) post("end", e);
            };
            window.addEventListener("pointermove", onMove, true);
            window.addEventListener("pointerup", onUp, true);
            window.addEventListener("pointercancel", onUp, true);
        },
        true
    );
};



// WEBPACK FOOTER //
// ./src/utils/headerDrag.js